var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsAudition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44.852,
    viewBox: "0 0 46 44.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_audition",
    transform: "translate(-1485 -914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M8.145,0h29.71A8.139,8.139,0,0,1,46,8.145V36.707a8.139,8.139,0,0,1-8.145,8.145H8.145A8.139,8.139,0,0,1,0,36.707V8.145A8.139,8.139,0,0,1,8.145,0Z",
    transform: "translate(1485 914)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M42.267,79.439H35.145L33.691,83.96a.331.331,0,0,1-.359.269H29.726c-.215,0-.269-.108-.215-.341l6.172-17.725a6.141,6.141,0,0,1,.2-.628,5.547,5.547,0,0,0,.161-1.22A.2.2,0,0,1,36.2,64.1h4.97c.126,0,.233.054.251.161l6.961,19.663c.054.215,0,.3-.2.3h-4a.287.287,0,0,1-.3-.215Zm-6.01-3.821h4.862c-.108-.395-.269-.879-.449-1.381-.179-.52-.341-1.076-.52-1.651-.2-.592-.359-1.166-.556-1.758s-.359-1.148-.52-1.7c-.161-.538-.287-1.041-.431-1.489h-.036a25.157,25.157,0,0,1-.646,2.476c-.287.915-.574,1.884-.879,2.835a26.32,26.32,0,0,1-.825,2.673Z",
    transform: "translate(1460.799 861.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M155.718,91.021v11.751c0,.52,0,.969.018,1.381.018.395.036.754.054,1.059.036.3.054.484.072.682.018.179-.054.251-.215.251h-3.283a.337.337,0,0,1-.359-.215l-.108-.484a1.472,1.472,0,0,1-.036-.395,5.463,5.463,0,0,1-2.171,1.184,7.757,7.757,0,0,1-2.135.287,6.238,6.238,0,0,1-2.081-.323,4.082,4.082,0,0,1-1.633-1.058,4.758,4.758,0,0,1-1.076-1.866,8.714,8.714,0,0,1-.377-2.727V91.039a.22.22,0,0,1,.2-.251H146.3a.22.22,0,0,1,.251.2v9.06a3.281,3.281,0,0,0,.556,1.991,2.443,2.443,0,0,0,1.973.736,3.669,3.669,0,0,0,1.31-.233,4.5,4.5,0,0,0,1.2-.628V91.021c0-.126.09-.215.269-.215h3.66a.185.185,0,0,1,.215.161A.066.066,0,0,0,155.718,91.021Z",
    transform: "translate(1368.16 839.502)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsAudition);
export default __webpack_public_path__ + "static/media/skills_audition.f1c02ea703236d15d660e9caa952f53c.svg";
export { ForwardRef as ReactComponent };